// @flow
import { createAction } from 'redux-actions';
import * as constants from './constants';

export const getHubOfflineNotificationsStatus = createAction(constants.GET_SENSE_HUB_OFFLINE_NOTICATIONS_STATUS);
export const setHubOfflineNotificationsStatus = createAction(constants.SET_SENSE_HUB_OFFLINE_NOTICATIONS_STATUS);
export const setDefaultMuting = createAction(constants.SET_DEFAULT_MUTING);
export const setDefaultMutingDone = createAction(constants.SET_DEFAULT_MUTING_DONE);
export const receivedHubOfflineNotificationsStatus = createAction(
    constants.RECEIVED_SENSE_HUB_OFFLINE_NOTICATIONS_STATUS
);
export const toggleMonitoringAll = createAction(constants.TOGGLE_MONITORING_ALL);
export const toggleMonitoringAllDone = createAction(constants.TOGGLE_MONITORING_ALL_DONE);
export const toggleMonitoringSensor = createAction(constants.TOGGLE_MONITORING_SENSOR);
export const toggleMonitoringSensorDone = createAction(constants.TOGGLE_MONITORING_SENSOR_DONE);
export const changeSenseLogsSelectedDay = createAction(constants.CHANGE_SENSE_LOGS_SELECTED_DAY, (id, selectedDay) => ({
    id,
    selectedDay
}));
export const deleteSenseEvent = createAction(constants.DELETE_SENSE_EVENT, (id, mediaId) => ({ id, mediaId }));
export const deleteSenseEventComplete = createAction(constants.DELETE_SENSE_EVENT_COMPLETE, (id, mediaId, error) => ({
    id,
    mediaId,
    error
}));
export const flagSenseMedia = createAction(constants.FLAG_SENSE_MEDIA, (id, mediaId, flag) => ({ id, mediaId, flag }));
export const flagSenseMediaComplete = createAction(constants.FLAG_SENSE_MEDIA_COMPLETE, (id, mediaId, flag, error) => ({
    id,
    mediaId,
    flag,
    error
}));
export const getSenseDayEventLogs = createAction(constants.GET_SENSE_DAY_EVENT_LOGS, (id, selectedDay) => ({
    id,
    selectedDay
}));
export const receiveSenseDayEventLogs = createAction(
    constants.RECEIVE_SENSE_DAY_EVENT_LOGS,
    (id, selectedDay, eventLogs, error) => ({
        id,
        selectedDay,
        eventLogs,
        error
    })
);
export const stopSenseDayEventLogsPolling = createAction(constants.STOP_SENSE_DAY_EVENT_LOGS_POLLING);



// WEBPACK FOOTER //
// ./src/core/state/products/sense/actions.js